import { format } from 'date-fns';

export const toDateOrNull = (value: any): Date | null => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDate = (
  value: any, 
  pattern: string = 'dd-MMM-yyyy', 
  fallback: string = 'Not specified'
): string => {
  const d = toDateOrNull(value);
  return d ? format(d, pattern) : fallback;
};

export const formatDateShort = (value: any): string => {
  return formatDate(value, 'dd MMM yyyy');
};
